module.exports = __webpack_public_path__ + "static/media/summary-like.d782717b.svg";